function Statistics252Changelog() {
  return (
    <div>
      <h6>DATA:</h6>
      <ul>
        <li className="bullet-item">All data sources updated</li>
        <li className="bullet-item">
          New Named Entity Recognition (NER) model for the identification of gene, disease and chemical
          mentions in the literature, that reached an average F1 score of <strong>0.88</strong>
        </li>
        <li className="bullet-item">
          New approach for the normalization of gene, disease and chemical mentions, based on embeddings of
          our dictionaries.
        </li>
        <li className="bullet-item">New attributes for diseases: prevalence and mode of inheritance</li>
        <li className="bullet-item">New attribute for chemicals: type of chemical extracted from ChEMBL</li>
      </ul>
      <h6>WEB:</h6>
      <p>New features:</p>
      <ul>
        <li className="bullet-item">
          New columns for diseases: Prevalence Type, Prevalence Class, Prevalence Geography, Mode of
          inheritance. Available on the tabs Diseases, GDAs and VDAs summary.{' '}
        </li>
        <li className="bullet-item">
          New column for chemicals: Chemical Type, available on the tab Chemicals.
        </li>
      </ul>
      <h6>REST API:</h6>
      <p>New release 1.9.0:</p>
      <ul>
        <li className="bullet-item">
          New fields for filtering: disease_prevalence_class, disease_prevalence_type,
          disease_prevalence_geo_area, disease_inheritance. Available on endpoints diseases, GDAs and VDAs
          summary and evidence.{' '}
        </li>
        <li className="bullet-item">
          New field ChemMoleculeType with possible values are Small molecule, Protein, Unknown, Antibody,
          Oligosaccharide, Antibody drug conjugate, Oligonucleotide, Enzyme, Gene and Cell. Available on
          endpoint chemicals.
        </li>
      </ul>
    </div>
  );
}

export default Statistics252Changelog;
